import {AxiosProcessor} from "../../shared/axios/AxiosProcessor";
const urlClient = '/client';

const state = {
    client: {},
    clients:[],
    clientDetails: {},
    clientsPageKey:{}
};

const getters = {
    getClient: state => {
        return state.client;
    },
    getClients: state => {
        return state.clients;
    },
    getClientDetails: state => {
        return state.clientDetails;
    },
    getClientsPageKey : state => {
        return state.clientsPageKey;
    }
};

const mutations = {
    setClient: (state, data) => {
        state.client = data;
    },
    setClients: (state, data) => {
        state.clients = data;
    },
    setClientDetails: (state, data) => {
        state.clientDetails = data;
    },
    setClientsPageKey: (state, data) => {
        state.clientsPageKey = data;
    }
};

const actions = {
    async setClient ({commit}, data) {
        //going backend
        let value = {};

        if(data.id) {
            value = await AxiosProcessor.put(urlClient+'/'+ data.id, data);
        }
        else {
            value = await AxiosProcessor.post(urlClient, data);
        }

        commit('setClient', value);
    },
    async getClient ({commit}, data) {
        let id = data.id;

        if (!id)
            throw {message: 'empty id. Please provide a valid id value 908789'};

        /**
         * First we check the state
         * then we check the list
         * then we go to backend
         */
        if(state.client.id && state.client.id === id)
            return;

        let client;
        let value = {};

        if (state.clients.length > 0) {
            client  = state.clients.find(pat => pat.id === id);
        }

        if(client)
        {
            value = client;
        }
        else
        {
            let response = await AxiosProcessor.get(urlClient+'/'+id);

            if(response.Item)
                value = response.Item;
        }

        commit('setClient', value);
    },
    async getClients ({commit}, data) {
        let url = urlClient;

        //going backend,
        let value = {};
        let response = await AxiosProcessor.list(url, data);

        if(response.Items)
            value = response.Items;

        if(response.LastEvaluatedKey)
            commit('setClientsPageKey', response.LastEvaluatedKey);

        commit('setClients', value);
    },
    async getClientDetails ({commit}, data){
        //going backend,
        let value = {};
        let response = await AxiosProcessor.get('/counter/client');

        if(response.Item)
            value = response.Item;

        commit('setClientDetails', value);
    },
    async deleteClient ({commit}, data){
        //going backend,
        let value = {};
        value = await AxiosProcessor.delete(urlClient+'/'+data.id);

        commit('setClient', value);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}